import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Home.css';

function Home() {
  const navigate = useNavigate();

  const handleTechnicianClick = () => {
    // Check if user is logged in
    const userData = localStorage.getItem('user');
    if (userData) {
      const user = JSON.parse(userData);
      // Redirect based on role
      if (user.role === 'technician') {
        navigate('/technician/dashboard');
      } else if (user.role === 'hirer') {
        navigate('/hirer/dashboard');
      } else {
        // Fallback (shouldn't happen)
        navigate('/select-role');
      }
    } else {
      // Not logged in → go to role selection
      navigate('/select-role');
    }
  };

  const handleOtherClick = (buttonName) => {
    alert(`${buttonName} section is under construction.`);
  };

  return (
    <div className="home-container">
      <h1 className="title">SkillArea</h1>
      <div className="button-grid">
        <button className="big-button" onClick={() => handleOtherClick('Freelancer')}>Freelancer</button>
        <button className="big-button" onClick={handleTechnicianClick}>Technician</button>
        <button className="big-button" onClick={() => handleOtherClick('Store')}>Store</button>
        <button className="big-button" onClick={() => handleOtherClick('Learning')}>Learning</button>
      </div>
    </div>
  );
}

export default Home;